module.exports = __webpack_public_path__ + "img/car-front.5b2a8e16.png";